import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import Modal from "react-responsive-modal";
import AssignCapsuleModalContent from '../Home/AssignCapsuleModalContent';
import TrelloCreateBoard from "../Account/CreateTrelloBoard"
import confirmationDesktop from '../../assets/confirmation_v2.svg';
import "./BasicCard.css";
import SnackBar from '../SnackBar/SnackBar';
import LikeComponent from './LikeComponent';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';


const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "601px",
        maxWidth: "395px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

const styles_confirmation = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        width: (window.innerWidth > 768) ? '20vw' : '80vw',
        top: '20vh',
        padding: "0px",
        background: "rgba(0,0,0,0)",
    }
};

const styles_loader = theme => ({
    root: {
    },
    buttonProgress: {
        color: '#0070A2',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -20,
        marginLeft: -12,
    },
});


const INITIAL_STATE = {
    assignCapsuleOpen: false,
    confirmationOpen: false,
    direction: null,
    nbPolls: 0,
    nbIdeas: 0,
    assigneeName: null,
    assigneeId: null,
    data: {},
    capsuleID: null,
    error: null,
    loading: true,
    timeFromAcceptance: 0,
    user: { firstname: "", lastname: "" },
    imageLoading: false,
};

class BasicCard extends Component {

    render() {
        return (
            <BasicCardComponent {...this.props} />
        );
    }
}


class BasicCardComponentBase extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE, capsuleID: this.props.capsule.id, current_user: "",
            active: this.props.active
        };
    }

    componentDidMount() {
        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }

            let querySnapshotUsers = await this.props.firebase.db.collection('users').get()
            const { capsule, fromSearchPage } = this.props

            if (capsule) {
                const data = capsule
                if (data.status && data.status !== "pending" && fromSearchPage) {
                    this.setState({ active: false })
                }
                const capsuleID = capsule.id
                const assigneeName = querySnapshotUsers.docs.filter(doc => doc.id === data.assigneeId).map(doc => doc.data().firstname + " " + doc.data().lastname)[0]

                let querySnapshotCreator = await this.props.firebase.db.collection("users").doc(capsule.creator).get()
                this.setState({ user: querySnapshotCreator.data() })

                let querySnapshotPolls = await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('polls').get()
                let pollsIds = querySnapshotPolls.docs.map(doc => doc.id)

                let querySnapshotIdeas = await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('ideas').get()
                let ideasIds = querySnapshotIdeas.docs.map(doc => doc.id)

                this.setState({
                    direction: this.props.direction,
                    nbPolls: pollsIds.length,
                    nbIdeas: ideasIds.length,
                    assigneeId: data.assigneeId,
                    assigneeName,
                    data,
                    capsuleID,
                    loading: false,
                })
            }
            this.getTimeFromAcceptance()
        })
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    assignCapsule = () => {
        this.openAssignCapsule();
    };

    openAssignCapsule = () => {
        this.setState({
            assignCapsuleOpen: true
        })
    }

    closeAssignCapsule = () => {
        this.setState({
            assignCapsuleOpen: false
        })
    }

    openConfirmation = () => {
        this.setState({
            confirmationOpen: true,
            imageLoading: true
        })
    }

    closeConfirmation = () => {
        this.setState({
            confirmationOpen: false
        })
    }

    getTimeFromAcceptance = () => {
        let { capsule } = this.props
        let now = new Date()
        if (capsule.acceptanceDate) {

            let acceptance = new Date(capsule.acceptanceDate)
            this.setState({ timeFromAcceptance: (now - acceptance) / 6.048e+8 }) //converts miliseconds in weeks
        }
        else {
            this.setState({ timeFromAcceptance: 0 })
        }
    }

    onLoadImage = () => {
        this.setState({ imageLoading: false })
    }

    render() {
        const { capsuleID, data, loading, assigneeId, timeFromAcceptance, user, imageLoading } = this.state
        const title = data.title
        const cardIndex = this.props.cardIndex || 0;
        const assigneeName = this.state.assigneeName || 'Default';
        const tagList = data.tags || [];
        const picture = data.image_url_capsule || require('../../assets/example-productivity.jpg');
        const { direction, classes } = this.props;
        const { nbPolls, nbIdeas } = this.state
        let active = this.state.active === undefined ? true : this.state.active
        let assigneeText = '';

        if (assigneeName !== 'Default') {
            assigneeText = 'Acceptée par ' + assigneeName;
        }
        const tagDisplay = [];

        if (tagList !== []) {
            if (tagList.length < 2) {
                for (const [index, value] of tagList.entries()) {
                    tagDisplay.push(
                        <div className="basic-card-tag" key={index}>#{value}</div>
                    )
                }
            }
            else {
                for (const [index, value] of tagList.slice(0, 2).entries()) {
                    tagDisplay.push(
                        <div className="basic-card-tag" key={index}>#{value}</div>
                    )
                }
            }
        }

        return (
            <div className="basic-card card">

                <img className={active ? "card-img-top img-cropper cursor-pointer" : "card-img-top img-cropper"}
                    onClick={() => this.props.onOpenCapsule(capsuleID)}
                    src={picture}
                    alt="Card"
                    onError={this.props.firebase.capsuleImgError} />

                <div className={active ? "basic-card-header cursor-pointer" : "basic-card-header"} onClick={() => this.props.onOpenCapsule(capsuleID)}>
                    <div className="basic-card-title">{title}</div>
                    <div className="basic-card-index-container">
                        <div className="basic-card-index">{cardIndex}</div>
                    </div>
                </div>

                <img className={active ? "basic-card-bottom-background cursor-pointer" : "basic-card-bottom-background"} onClick={() => this.props.onOpenCapsule(capsuleID)} src={require('../../assets/cards/card_white_shape.svg')} alt="Bottom" />
                <div className="basic-card-btn-container">
                    <TrelloCreateBoard
                        capsuleName={title}
                        capsuleId={capsuleID}
                        capsule={this.props.capsule}
                        assigneeId={assigneeId}
                        currentUserId={this.props.firebase.auth.currentUser.uid}
                        loading={loading}
                        active={active}
                    />
                    <Tooltip title={direction === 'up' ? 'Up capsule' : 'Down capsule'} aria-label="up/down">
                        <img className={active ? "center-button cursor-pointer" : "center-button-inactive"}
                            src={direction === 'up' ? require('../../assets/cards/icon_up.svg') : require('../../assets/cards/icon_down.svg')}
                            onClick={active ? (direction === 'up' ? () => this.props.upCapsule(capsuleID) : () => this.props.downCapsule(capsuleID)) : null}
                            alt="Direction" />
                    </Tooltip>

                    {loading ? <img className="basic-card-side-button-assigned"
                        src={require('../../assets/cards/icon_share.svg')} alt="Assign" /> : null}

                    {!loading && active ?
                        <Tooltip title="Propulser" aria-label="propulser">
                            <img className={assigneeName === 'Default' ? "basic-card-side-button cursor-pointer" : "basic-card-side-button-assigned"}
                                onClick={assigneeName === 'Default' && active ? this.assignCapsule : null}
                                src={require('../../assets/cards/icon_share.svg')} alt="Assign" /></Tooltip> : null}

                    {!loading && !active ? <img className="basic-card-side-button-assigned"
                        src={require('../../assets/cards/icon_share.svg')} alt="Assign" /> : null}
                </div>

                <div className="basic-card-body">
                    <p className={timeFromAcceptance > 6 ? "basic-card-adressing-text color-red" : "basic-card-adressing-text color-orange"} hidden={timeFromAcceptance < 3}>{assigneeText}</p>
                    <p className="basic-card-adressing-text" hidden={timeFromAcceptance >= 3}>{assigneeText}</p>
                    <p className="activated-text-blue"> Créée par {user.firstname} {user.lastname}</p>
                    <p className="basic-card-other-text">{nbPolls} {(nbPolls === 1) ? 'sondage' : 'sondages'}</p>
                    <p className="basic-card-other-text">{nbIdeas} {(nbIdeas === 1) ? 'idée' : 'idées'}</p>

                    <div className="basic-card-footer">
                        {tagDisplay}
                        <LikeComponent
                            idcapsule={capsuleID}
                            card={"basic"}
                        />
                    </div>
                </div>

                <Modal
                    open={this.state.assignCapsuleOpen}
                    onClose={this.closeAssignCapsule}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <AssignCapsuleModalContent
                        onClose={this.closeAssignCapsule}
                        openConfirmation={this.openConfirmation}
                        capsuleID={capsuleID} />

                </Modal>
                <Modal
                    open={this.state.confirmationOpen}
                    onClose={this.closeConfirmation}
                    center
                    showCloseIcon={true}
                    classNames={{ 'closeButton': 'closeIconModal' }}
                    styles={styles_confirmation}
                    closeIconSvgPath={<path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" fill="#FFFFFF"></path>}
                >
                    {imageLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    <img src={confirmationDesktop} className="h-100 w-100 p-0 object-fit-cover" onLoad={this.onLoadImage} alt="confirmation" />
                </Modal>
                <SnackBar
                    open={this.props.snackbarUpDownOpen}
                    handleClose={this.props.closeSnackbar}
                    messageSnackBar={this.props.messageSnackBar}
                    undo={this.props.undo} />
            </div>
        );
    }
}

const BasicCardComponent = withRouter(withFirebase(withStyles(styles_loader)(BasicCardComponentBase)));

export default BasicCard;
export { BasicCardComponent };